<template>
  <div class="box__list">
    <header class="box__list__header">
      <h3 class="box__list__title">{{ $t("shop.header") }}</h3>

      <div class="box__list__header-button">
        <div class="close" @click.prevent="closeItemsList"></div>
      </div>
    </header>
    <div class="box__list__content">
      <div :class="getScrollOverlayClass">
        <vue-scroll
          :ref="`boxid${boxId}`"
          :class="`scroll-list js-prizes-scroll boxid${boxId}`"
          :ops="ops"
        >
          <div v-for="(item, index) in listItems" :key="index" :class="getItemClass(item)">
            <span :name="getTooltipName(item, index)"
              >{{ item.title }} ({{ itemDuration(item.reward).text }})</span
            >
            <i v-if="isItemFetched(item)" class="icon icon-check"></i>

            <tippy
              :to="getTooltipName(item, index)"
              theme="wf-bp"
              :arrow="false"
              placement="top-end"
            >
              <div>
                <img :src="getImageSrc(item)" :alt="item.title" />
                <p>{{ item.title }} ({{ itemDuration(item.reward).text }})</p>
              </div>
            </tippy>
          </div>
        </vue-scroll>
      </div>
    </div>
  </div>
</template>

<script>
import ItemsScrollListMixin from "../../Common/ItemsScrollListMixin";
import ItemDurationMixin from "../../Common/ItemDurationMixin";

export default {
  name: "ShopListItemPrizes",

  mixins: [ItemsScrollListMixin, ItemDurationMixin],

  props: {
    boxId: Number,
    isRepeatable: Boolean,
  },

  mounted() {
    window.addEventListener("keyup", e => {
      if (e.keyCode == 27) {
        this.closeItemsList();
      }
    });

    const scroll_block = document.querySelector(`.js-prizes-scroll.boxid${this.boxId} .__view`);
    scroll_block.addEventListener("wheel", () => {
      this.stopParentScroll();
    });
  },

  updated() {
    const scroll_block = document.querySelector(`.js-prizes-scroll.boxid${this.boxId} .__view`);
    scroll_block.addEventListener("wheel", () => {
      this.stopParentScroll();
    });
  },

  methods: {
    getItemClass(item) {
      return ["scroll-item", this.isItemFetched(item) ? "item-fetched" : ""];
    },

    isItemFetched(item) {
      return !this.isRepeatable && item.fetched;
    },

    closeItemsList() {
      this.$emit("closeItemsList");
    },

    getImageSrc(item) {
      let image_id = item.reward.item.achievement
        ? `achive_${item.reward.item.id}`
        : item.reward.item.id;

      return `https://wf.cdn.gmru.net/static/wf.mail.ru/img/main/items/${image_id}.png`;
    },

    getTooltipName(item, index) {
      return `item_tooltip-${item.reward.item.id}_${index}_${this.boxId}`;
    },

    stopParentScroll() {
      this.$emit("stopBoxesScroll");
    },
  },
};
</script>
